import { DocumentServices } from '@/service/DocumentService'
import { ref } from 'vue'
import { useRoute } from 'vue-router'
import { AxiosError, isAxiosError } from 'axios'
import { useNotification } from '@gohighlevel/ghl-ui'

const loading = ref(false)
export const usePublicForm = () => {
  const route = useRoute()
  const id = route.params.documentId as string
  const notification = useNotification()

  const submitForm = async (payload: {
    firstName: string
    lastName: string
    email: string
  }) => {
    loading.value = true
    try {
      const response = await DocumentServices.savePublicFormResponse({
        ...payload,
        id,
        locale: (route.query.locale as string) || 'en-US',
      })
      if (response && response.data.url) {
        window.location.href = response.data.url
      }
    } catch (error) {
      console.error(error)
      // Handle 400 errors with message from API
      if (isAxiosError(error)) {
        const axiosError = error as AxiosError<{ message?: string }>
        if (
          axiosError.response?.status === 400 &&
          axiosError.response?.data?.message
        ) {
          notification.error({
            title: axiosError.response.data.message,
            description: '',
            duration: 10000,
          })
        }
      }
      throw error // Re-throw to allow component to handle if needed
    } finally {
      loading.value = false
    }
  }

  const confirmFormValidity = async () => {
    try {
      loading.value = true
      const resp = await DocumentServices.validateForm(id)
      return resp.data
    } catch (error) {
      console.error(error)
    } finally {
      loading.value = false
    }
  }

  return {
    submitForm,
    loading,
    confirmFormValidity,
  }
}
